export default __webpack_public_path__ + "static/media/youtube.49da7493.png";